import React from 'react'
import { Link, NavLink } from "react-router-dom";

function Experience() {
  return (
    <section className='Portfolio'>
            <div className="port2">
                <div className="container" style={{padding: '0'}}>
                    <div className="row d-flex align-items-center">    {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300" */}
                        <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="d-flex gap-3 align-items-center">
                                <hr className='hr3' />
                                <h3 className='heading1 m-0'>Experience</h3>
                            </div>
                            <h2>
                                Grow Your Online Presence
                            </h2>
                            <p style={{padding: '0 221px 0 0 '}}>
                            Elevate your brand with our strategic solutions. From tailored campaigns to innovative strategies, we help you connect, engage, and grow online effortlessly.
                            </p>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex align-items-center justify-content-center">
                            <Link to = "/service" className="btn_1 ">Get Started</Link>
                        </div>
                        <hr className='mt-5' />
                    </div>
                </div>
            </div>
        </section>
  )
}

export default Experience
